import React from 'react';
import { FadeIn } from './FadeIn';
import { CTAButton } from './CTAButton';
import { Check, ShieldCheck, Zap } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
export function OfferSection() {
  const sectionId = 'oferta';
  return <section id="oferta" className="py-10 md:py-32 bg-cream-100 relative overflow-hidden" data-id="element-107">
      {/* Decorative background */}
      <div className="absolute top-0 left-0 w-full h-full pointer-events-none" data-id="element-108">
        <div className="absolute top-[-20%] right-[-10%] w-[60%] h-[60%] rounded-full bg-sage-200/40 blur-3xl" data-id="element-109"></div>
        <div className="absolute bottom-[-20%] left-[-10%] w-[60%] h-[60%] rounded-full bg-coral-100/40 blur-3xl" data-id="element-110"></div>
      </div>

      <div className="max-w-5xl mx-auto px-6 lg:px-8 relative z-10" data-id="element-111">
        <div className="bg-white rounded-[2.5rem] shadow-xl p-8 md:p-12 lg:p-16 border border-cream-200" data-id="element-112">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-113">
            {/* Image Side */}
            <FadeIn direction="right" data-id="element-114">
              <div className="relative mx-auto w-full max-w-sm lg:max-w-none" data-id="element-115">
                <div className="absolute inset-0 bg-sage-100 rounded-full blur-3xl opacity-60 transform scale-90" data-id="element-116"></div>
                <img src="https://cdn.magicpatterns.com/uploads/rzZNtrxzqEz2mimBwc3892/PROTOCOLO_ANTI-INFLAMATORIO_21D_Mockup.png" alt="Protocolo Anti-Inflamatorio 21D" className="relative z-10 w-full h-auto object-contain drop-shadow-xl" data-id="element-117" />
              </div>
            </FadeIn>

            {/* Content Side */}
            <FadeIn direction="left" delay={0.2} data-id="element-118">
              <div className="text-center lg:text-left" data-id="element-119">
                <h2 className="text-3xl md:text-4xl font-bold text-charcoal mb-6" data-id="element-120">
                  Recupera tu bienestar hoy mismo.
                </h2>

                <p className="text-lg text-charcoal-light mb-8 font-sans" data-id="element-121">
                  El Protocolo Anti-Inflamatorio 21D completo, incluyendo la
                  Guía de Rescate y el Checklist de Compras por un pago único.
                </p>

                <div className="bg-sage-50 rounded-2xl p-6 mb-8 border border-sage-100 inline-block w-full" data-id="element-122">
                  <span className="text-sm font-bold text-sage-600 uppercase tracking-wider mb-2 block" data-id="element-123">
                    Precio Especial de Lanzamiento
                  </span>
                  <div className="flex items-baseline justify-center lg:justify-start gap-2" data-id="element-124">
                    <span className="text-5xl md:text-6xl font-bold text-charcoal" data-id="element-125">
                      $8.999
                    </span>
                    <span className="text-xl text-charcoal-light font-sans" data-id="element-126">
                      ARS
                    </span>
                  </div>
                </div>

                <div id="oferta-cta" className="flex flex-col items-center lg:items-start gap-4" data-id="element-127">
                  <CTAButton className="w-full sm:w-auto" onClick={() => {
                  trackAddToCart();
                  window.open('https://www.saboressdevidaa.shop/cart/44833151221830:1', '_blank');
                }} data-id="element-128" />

                  <div className="flex flex-wrap justify-center lg:justify-start gap-4 mt-4 text-sm text-charcoal-light font-sans" data-id="element-129">
                    <div className="flex items-center gap-1.5" data-id="element-130">
                      <ShieldCheck className="w-4 h-4 text-sage-600" data-id="element-131" />
                      <span data-id="element-132">Pago seguro y cifrado</span>
                    </div>
                    <div className="flex items-center gap-1.5" data-id="element-133">
                      <Zap className="w-4 h-4 text-coral-500" data-id="element-134" />
                      <span data-id="element-135">Acceso inmediato</span>
                    </div>
                  </div>
                </div>
              </div>
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
}